import { BaseService } from './BaseService.js';

/**
 * Settings Service
 * Handles application settings using Laravel API
 */
export class SettingsService extends BaseService {
  constructor() {
    super('settings'); // Laravel endpoint: /api/settings
  }

  /**
   * Get setting by key
   */
  async get(key) {
    return this.customCall(key);
  }

  /**
   * Update setting by key
   */
  async set(key, value) {
    return this.customCall(key, 'PUT', { value });
  }

  /**
   * Get all settings
   */
  async getAll() {
    return this.list();
  }

  /**
   * Get settings by group
   */
  async getGroup(group) {
    return this.customCall(`group/${group}`);
  }

  /**
   * Update multiple settings
   */
  async updateMultiple(settings) {
    return this.customCall('bulk', 'PUT', { settings });
  }

  /**
   * Reset settings to defaults
   */
  async resetToDefaults(group = null) {
    const params = group ? { group } : {};
    return this.customCall('reset', 'POST', params);
  }
}

// Export singleton instance for backward compatibility
const settingsService = new SettingsService();
export default settingsService; 